// src/useLanguageSetup.js
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function useLanguageSetup() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Default values
    let lang = "ar";
    let dir = "rtl";

    // ✅ Read from iframe URL params
    const params = new URLSearchParams(window.location.search);
    if (params.get("lang")) {
      lang = params.get("lang");
    }
    if (params.get("dir")) {
      dir = params.get("dir");
    } else {
      // if dir not explicitly passed, infer from lang
      dir = lang === "ar" ? "rtl" : "ltr";
    }

    // Apply to <html> tag inside iframe
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;

    // Tell i18next to switch language
    i18n.changeLanguage(lang);
  }, [i18n]);
}
